import { IonRouterOutlet, IonSplitPane } from "@ionic/react";
import CallProvider from "../../components/Shared/WebRTCCall/CallProvider";
import React, {
  Suspense,
  useEffect,
  useLayoutEffect,
  useState,
  createContext,
  useRef,
} from "react";
import { Route, useHistory } from "react-router";
import Header from "../../components/Shared/Header/Header";
import Menu from "../../components/Shared/Menu/Menu";
import { isPlatform } from "@ionic/react";

import Home from "../../pages/Home/Home";
import MyPatients from "../../pages/MyPatients/MyPatients";
import NurseManagement from "../../pages/NurseManagement/NurseManagement";
import onCallLookUpMainPage from "../../pages/OnCallLookUp/OnCallLookUpPage";
import StatusBoardMainPage from "../../pages/StatusBoard/StatusBoard";
import UnitBeds from "../../pages/UnitBeds/UnitBeds";
import UnitDeptListPage from "../../pages/UnitDeptList/unitDeptListPage";
import "./AppLayout.scss";
import ReminderAlert from "../../components/Shared/ReminderAlert/ReminderAlert";
import { ReminderAlertService } from "../../services/ReminderAlert.service";
import FooterMenu from "../../components/Shared/FooterMenu/FooterMenu";
import { StorageService, utilService } from "../../services";
import { pushNotificationService } from "../../services/PushNotification.service";
import CareTeamAlert from "../../components/Shared/CareTeamAlert/CareTeamAlert";
import { ContactNumAlertService } from "../../pages/MenuSettings/components/ContactNum/ContactNumAlert/ContactNumAlert.service";
import { dataTransferService } from "../../services/dataTransferService";
import { useToast } from "@agney/ir-toast";
import { CONSTANTS } from "../../constants";
import { statusBoardService } from "../../pages/StatusBoard/StatusBoard.service";
import { Capacitor } from "@capacitor/core";
import IncomingCallUser from "../../components/Shared/Call/Components/IncomingCallUser/IncomingCallUser";
import { useSelector } from "react-redux";
import { settingsService } from "../../pages/MenuSettings/components/Settings/Settings.service";
import _ from "lodash";
import { smsService } from "../../components/Shared/Sms/Sms.service";
import { DoctorInfoReq } from "../../components/Shared/Sms/Sms.model";
import UserMessage from "../../pages/UserMessages/UserMessage";
import UserChatMainPage from "../../pages/UserChat/UserChatMainPage/UserChatMainPage";
import EmtHomeComponent from "../../pages/EmtHome/EmtHome";
import PatientFormComponent from "../../pages/PatientForm/PatientForm";
import CaseHistoryComponent from "../../pages/CaseHistory/CaseHistory";
import { EMSAlertService } from "../../services/EMSAlert.service";
import PatientAlert from "../../components/Shared/PatientAlert/PatientAlert";
import { loggedInUserService } from "../../services/loggedInUser.service";
import TeamsPage from "../../pages/Teams/teams";
import ProviderAlert from "../../components/Shared/ProviderAlert/ProviderAlert";
import CareTeamEmergencyAlert from "../../components/Shared/CareTeamEmergencyAlert/CareTeamEmergencyAlert";
import { CaseHistoryService } from "../../pages/CaseHistory/CaseHistory.service";
import SearchWithSelectBar from "../../pages/GlobalSearch/SearchwithSelect";
import { StatusBar, Style } from "@capacitor/status-bar";
import N2NGlobalSearch from "../../pages/N2NGlobalSearch/N2NGlobalSearch";
import MembershipPlan from "../../pages/Membership/MembershipPlan";
import JsSIP from "jssip"; // Replaced Twilio with JsSIP
import ContactNumAlert from "../../pages/MenuSettings/components/ContactNum/ContactNumAlert/ContactNumAlert";
import IdleTimeout from "../../components/Shared/IdleTimeout/IdleTimeout";
import { iceServers, sipDomain, sipServer, sipWebSocketUrl } from "../../services/telephonyConfig";

const Notifications = React.lazy(
  () => import("../../pages/Notifications/Notifications")
);
const OnCallLookUpFavComponent = React.lazy(
  () => import("../../pages/OnCalllookUpFavorites/OnCallLookUpFavorites")
);
const SitesPage = React.lazy(() => import("../../pages/Sites/sites"));
const UnassignedShift = React.lazy(
  () => import("../../pages/UnassignedShifts/UnassignedShifts")
);
const CallSchedule = React.lazy(
  () => import("../../pages/CallSchedule/CallSchedule")
);
const FileShareMainPage = React.lazy(
  () => import("../../pages/FileShare/FileShareMainPage")
);
const MenuSettings = React.lazy(
  () => import("../../pages/MenuSettings/MenuSettings")
);

// SIP configuration comes from window._env_ (see services/telephonyConfig).
// It used to be hardcoded to the vendor's Asterisk, which a private
// deployment cannot reach -- and which should not carry another operator's
// calls in any case.

interface AppLayoutProps {}

export const MenuContext: any = createContext({});
JsSIP.debug.enable('JsSIP:*');
const AppLayout: React.FC<AppLayoutProps> = () => {
  const incomingCall = useSelector((state: any) => {
    return state.incomingCallReducer.incomingCapToken;
  });

const uaRef = useRef<any>(null);
    const sipCred = JSON.parse(localStorage.getItem("sipCred") || "[]");
  const [showModalAlert, setShowModalAlert] = useState<any>(false);
  const [menuListGlobal, setMenuListGlobal] = useState<any>([]);
  const [showContactModalAlert, setShowContactModalAlert] = useState<any>(false);
  const [doctorInfoData, setDoctorInfoData]: any = useState([]);
  const [reminderAlertParams, setReminderAlertParams] = useState<any>();
  const [contactNumAlertParams, setContactNumAlertParams] = useState<any>();
  const [isIos, setIsIos] = useState(false);
  const [showCareTeamPopup, setShowCareTeamPopup] = useState(false);
  const loggedInUserGuid = utilService.getLoggedUserGuid()
  
  // VoIP State
  const [enableIncomingScreen, setIncomingScreen] = useState(false);
  const [careTeamAlertParams, setCareTeamAlertParams] = useState<any>();
  const [showIncomingCallUserModal, setShowIncomingCallUserModal] = useState(false);
  
  // JsSIP State Replaces Twilio State
  const [userAgent, setUserAgent] = useState<any>(null);
  const [session, setSession] = useState<any>(null);
  const [sipStatus, setSipStatus] = useState('Disconnected');
  const [registered, setRegistered] = useState(false);
  
  // These would typically come from loggedInUser service or Storage
const [sipUser, setSipUser] = useState(sipCred?.[0]?.username || "");
const [sipPassword, setSipPassword] = useState(sipCred?.[0]?.password || "");

  
  const history = useHistory();
  const Toast = useToast();
  const [patientInfoData, setPatientInfoData]: any = useState([]);
  const [emsPatientStatus, setEMSPatientStatus] = useState(false);
  const [emsRejectedPatientStatus, setEMSRejectedPatientStatus] = useState(false);
  const [rejectedPatientInfoData, setRejectedPatientInfoData]: any = useState([]);
  const [providerEmergencyCaseListData, setProviderEmergencyCaseListData]: any = useState([]);
  const [careTeamListData, setCareTeamListData]: any = useState([]);
  const [emsProviderAlertStatus, setEmsProviderAlertStatus] = useState(false);
  const [emsCareTeamAlertStatus, setEmsCareAlertStatus] = useState(false);
  const [seconds, setSeconds]: any = useState(0);
  var [isEMTUser, checkEMTUser]: any = useState(false);
  const [reminderList, setReminderList] = useState<any[]>([]);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Reference for audio element
  const remoteAudioRef = useRef<HTMLAudioElement>(null);

  // The split pane itself stays full-height (top: 0 in AppLayout.scss) so the
  // sidebar has no gap above its logo. Only ".page-content" needs to sit
  // below the header, using this measured height instead of a hardcoded
  // guess (56px / 10.7vh for iOS used to drift out of sync with whatever the
  // header actually renders at).
  const headerWrapperRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(56);

  useEffect(() => {
    const el = headerWrapperRef.current;
    if (!el) return;
    const observer = new ResizeObserver((entries) => {
      const height = entries[0]?.contentRect?.height;
      if (height) setHeaderHeight(height);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // --- JsSIP Cleanup Effect ---
  useEffect(() => {
    return () => {
      if (userAgent) userAgent.stop();
    };
  }, [userAgent]);

  // subscribe the reminder alert status
  useEffect(() => {
    ReminderAlertService.showReminderAlert.subscribe((reminderParams: any) => {
      if (
        !utilService.isEmpty(reminderParams) &&
        utilService.checkUserRole("Nurse")
      ) {
        setShowModalAlert(true);
        setReminderAlertParams(reminderParams);
        const list = reminderList
        list?.push(reminderParams)
        setReminderList(list);
      }
    });
  }, []);

  // subscribe the contact num alert status
  useLayoutEffect(() => {
    ContactNumAlertService.showContactNumAlert.subscribe(
      (contactNumParams: any) => {
        if (!utilService.isEmpty(contactNumParams)) {
          const currentDate = new Date();
          const selectedDate = new Date(contactNumParams.time);

          if (
            selectedDate.getFullYear() === currentDate.getFullYear() &&
            selectedDate.getMonth() === currentDate.getMonth() &&
            selectedDate.getDate() === currentDate.getDate()
          ) {
            setShowContactModalAlert(true);
            setContactNumAlertParams(contactNumParams);
          }
        }
      }
    );
  }, []);

  useEffect(() => {
    loggedInUserService.loggedInUserData.subscribe((data: any) => {
      let isEmtUser = checkIsEMTUser(data?.userData);
      checkEMTUser(isEmtUser);
      // NOTE: You might want to set SIP User/Pass here based on logged in user data
    });
  }, []);

  useEffect(() => {
    let interval: any = null;
    interval = setInterval(() => {
      setSeconds((seconds: number) => seconds + 1);
    }, 1000);
    renderSwitch();
    return () => clearInterval(interval);
  }, [seconds]);

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  const renderSwitch = () => {
    if (seconds % 30 == 0 && !isEMTUser) {
      fetchPatientData();
      rejectedPatientData();
      addProviderAlert();
      addCareTeamMembersAlert();
    } else if (seconds % 30 == 0 && isEMTUser) {
      rejectedPatientData();
    }
  };

  // ... [Existing API calls: fetchPatientData, rejectedPatientData, etc. remain unchanged] ...
  // Added brevity here for the functions fetchPatientData, rejectedPatientData, addProviderAlert, addCareTeamMembersAlert 
  // (Assuming they are exactly as in your original code)
  async function updatePatientListData() {
    const respPatientListResult: any = await CaseHistoryService.getUpdatedPatientHistory();
  }
  async function fetchPatientData() {
    const respPatientListResult: any = await EMSAlertService.getEMSAlertFromServer();
    const isValid = respPatientListResult.isSuccess && respPatientListResult.result?.length > 0 && respPatientListResult.result?.[0]?.patients_available;
    if (isValid) {
      setEMSPatientStatus(respPatientListResult.result?.[0]?.patients_available);
      setPatientInfoData(respPatientListResult.result?.[0]?.patient_data);
    }
  }
  async function rejectedPatientData() {
    const respPatientListResult: any = await EMSAlertService.getRejectPatientList();
    const isValid = respPatientListResult.isSuccess && respPatientListResult.result?.length > 0 && respPatientListResult.result?.[0]?.rejected_patients_available;
    if (isValid) {
      setEMSRejectedPatientStatus(respPatientListResult.result?.[0]?.rejected_patients_available);
      setRejectedPatientInfoData(respPatientListResult.result?.[0]?.rejected_patient_data);
    }
  }
  async function addProviderAlert() {
    const respProviderListResult: any = await EMSAlertService.getProvidersList();
    const isValid = respProviderListResult.isSuccess && respProviderListResult.result?.length > 0;
    if (isValid) {
      setEmsProviderAlertStatus(respProviderListResult.result?.[0]?.emergency_provider_alert_data_available);
      setProviderEmergencyCaseListData(respProviderListResult.result?.[0]?.emergency_provider_alert_data);
    }
  }
  async function addCareTeamMembersAlert() {
    const respProviderListResult: any = await EMSAlertService.getCareTeamMembersList();
    const isValid = respProviderListResult.isSuccess && respProviderListResult.result?.length > 0;
    if (isValid) {
      setEmsCareAlertStatus(respProviderListResult.result?.[0]?.care_team_user_alert_data_available);
      setCareTeamListData(respProviderListResult.result?.[0]?.care_team_user_alert_data);
    }
  }

  useLayoutEffect(() => {
    pushNotificationService.showCareTeamAlert.subscribe((alertParams: any) => {
      if (!utilService.isEmpty(alertParams)) {
        setShowCareTeamPopup(true);
        setCareTeamAlertParams(alertParams);
      }
    });
  }, []);

  useLayoutEffect(() => {
    ReminderAlertService.reminderListUpdated.subscribe((list: any) => {
      if (list) {
        ReminderAlertService.reminderData = list;
        ReminderAlertService.getReminderAlerts(list);
      }
    });
  }, []);

  useLayoutEffect(() => {
    ContactNumAlertService.contactDetailsUpdated.subscribe((list: any) => {
      if (list) {
        ContactNumAlertService.contactNumData = list;
        ContactNumAlertService.getContactNumAlerts(list);
      }
    });
  }, []);

  useLayoutEffect(() => {
    statusBoardService.bedTransferOrSwap.subscribe(() => {
      if (statusBoardService.isBedSwappedOrTransferredId) {
        ReminderAlertService.setUpdatedReminderList();
      }
    });
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getUnAuthorizedAction.subscribe(
      (data: any) => {
        if (data === true) {
          Toast.error(CONSTANTS.MESSAGES.SESSION_EXPIRED);
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  useEffect(() => {
    const isDarkMode = getThemeStatusFromStorage();
    toggleDarkModeHandler(isDarkMode);

    if (Capacitor.getPlatform() === "ios") {
      if (isDarkMode === true) {
        StatusBar.setStyle({ style: Style.Dark });
      } else {
        StatusBar.setStyle({ style: Style.Light });
      }
    }
  }, [isDarkMode]);

// --- REPLACED TWILIO INITIALIZATION WITH JSSIP ---
useEffect(() => {
  let ua: any = null;
  if (uaRef.current || !sipUser || !sipPassword) return;

  // const timer = setTimeout(() => {
 
    const socket = new JsSIP.WebSocketInterface(sipWebSocketUrl());
    const configuration = {
      sockets: [socket],
      uri: `sip:${sipUser}@${sipDomain()}`,
      password: sipPassword,
      register: true,
      session_expires: 180,
        iceServers: iceServers()
    };

    ua = new JsSIP.UA(configuration);
    uaRef.current = ua;

    ua.on('connected', () => console.log('test call out Connected to WSS'));
    ua.on('disconnected', (e: any) => {
      console.log("test call out disconnected", e, e.cause, e.socket ? e.socket.url : '');
    });
    ua.on('registered', () => {
      console.log("test call out registered");
    });
    ua.on('registrationFailed', (e: any) => {
      console.log("test call out registrationFailed", "Cause:", e.cause, "Response:", e.response?.status_code, e.response?.reason_phrase);
    });

  ua.on('newRTCSession', (data: any) => {
    const newSession = data.session;
    const request = data.request;
    
    console.log("Full SIP Request:", request.toString());
    // 1. Extract the User ID from the custom SIP header
const userDETAIL = request.getHeader('X-User-Id') || request.getHeader('x-user-id');
// const userDETAIL = "7CAE-13E6-DCF3-4B0";
// const callerName = newSession.session.remote_identity.display_name;
    console.log("Incoming User ID extracted:", userDETAIL);

    if (newSession.direction === 'incoming') {
      // 2. TRIGGER API CALL: If we have the ID, fetch the full profile immediately
      if (userDETAIL) {
        const paramsDoctorInfo: DoctorInfoReq = {
          guid: userDETAIL, // Passing the extracted ID
          reg_code: utilService.getNetwork(),
          n2n_network: "" 
        };
        fetchCallerInfo(paramsDoctorInfo);
      }

      // Handle Media/PeerConnection for incoming audio
      newSession.on('peerconnection', (e: any) => {
        e.peerconnection.ontrack = (event: any) => {
          if (remoteAudioRef.current) {
            remoteAudioRef.current.srcObject = event.streams[0];
            remoteAudioRef.current.play().catch(err => console.error("Audio play failed", err));
          }
        };
      });

      newSession.on('failed', (e: any) => {
        console.log("Call Failed - Cause:", e.cause);
        setSession(null);
        setIncomingScreen(false);
        setShowIncomingCallUserModal(false);
        setDoctorInfoData([]); // Clear data for next call
      });

      newSession.on('ended', (e: any) => {
        console.log("Call Ended - Cause:", e.cause);
        setSession(null);
        setIncomingScreen(false);
        setShowIncomingCallUserModal(false);
        setDoctorInfoData([]); // Clear data for next call
      });

      // 3. Update UI state to trigger the modal
      setSession(newSession);
      setIncomingScreen(true);
      setShowIncomingCallUserModal(true);
    }
  });

    ua.start();
    setUserAgent(ua);
  // }, 50); // 500ms delay helps avoid Asterisk double-connection flood

  return () => {
    if (uaRef.current) {
      uaRef.current.stop();
      uaRef.current = null;
    }
  };
}, [sipUser, sipPassword]);


useEffect(() => {
  // Warm the microphone only when the user has ALREADY granted it.
  //
  // This used to call getUserMedia unconditionally on every load, which threw
  // a permission prompt at the user the moment they signed in, with nothing on
  // screen to explain what it was for -- and logged an error on every page for
  // everyone who said no (or whose browser auto-blocked it, as Chrome does for
  // prompts with no user gesture). Permission is requested at the point of use
  // instead: startListening() in the speech component, and the call flow when
  // a call actually starts.
  let cancelled = false;
  const warmIfAlreadyGranted = async () => {
    try {
      const status = await (navigator as any).permissions?.query({ name: "microphone" as any });
      if (cancelled || !status || status.state !== "granted") return;
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
    } catch {
      // Permissions API unsupported, or the device has no microphone. Nothing
      // to warm, and nothing worth telling the user about.
    }
  };
  warmIfAlreadyGranted();
  return () => { cancelled = true; };
}, []);

  const registerSIP = () => {
    if (userAgent) {
      userAgent.stop();
      setUserAgent(null);
      setRegistered(false);
    }

    const socket = new JsSIP.WebSocketInterface(sipWebSocketUrl());
    const configuration = {
      sockets: [socket],
      uri: `sip:${sipUser}@${sipDomain()}`,
      password: sipPassword,
      register: true,
      iceServers: iceServers()
    };

    const ua = new JsSIP.UA(configuration);

    ua.on('connected', () => console.log('Connected to WSS'));
    ua.on('disconnected', () => {
      console.log('Disconnected from WSS');
      setRegistered(false);
      setSipStatus('Disconnected');
    });
    ua.on('registered', () => {
      console.log('Registered as ' + sipUser);
      setRegistered(true);
      setSipStatus('Registered');
    });
    ua.on('registrationFailed', (e) => {
      console.log('Registration Failed: ' + e.cause);
      setRegistered(false);
    });

    ua.on('newRTCSession', (data: any) => {
      const newSession = data.session;
const request = data.request;

  const userId =
    request?.getHeader('X-User-Id') ||
    request?.getHeader('X-USER-ID');

  console.log('X-User-Id:', userId);
      if (newSession.direction === 'incoming') {
        console.log('Incoming Call from ' + newSession.remote_identity.uri.user);
        
        // Setup Media Handling for Incoming
        newSession.on('peerconnection', (e: any) => {
          e.peerconnection.ontrack = (event: any) => {
            if (remoteAudioRef.current) {
              remoteAudioRef.current.srcObject = event.streams[0];
              remoteAudioRef.current.play().catch(e => console.error("Audio play failed", e));
            }
          };
        });

        newSession.on('ended', () => {
          console.log('Call Ended');
          setSession(null);
          setIncomingScreen(false);
          setShowIncomingCallUserModal(false);
        });

        newSession.on('failed', (e: any) => {
          console.log('Call Failed: ' + e.cause);
          setSession(null);
          setIncomingScreen(false);
          setShowIncomingCallUserModal(false);
        });

        // Trigger UI
        setSession(newSession);
        setIncomingScreen(true);
        setShowIncomingCallUserModal(true);
        
        // Extract Caller ID for existing logic
        getCallerDetailsFromSession(newSession);
      }
    });

    ua.start();
    setUserAgent(ua);
  };

  const getCallerDetailsFromSession = (session: any) => {
    // Adapter to match existing logic flow with JsSIP Session
    const callerUri = session.remote_identity.uri.toString();
    const callerUser = session.remote_identity.uri.user;
    
    // NOTE: JsSIP headers access is different from Twilio params. 
    // You may need to inspect `session.request.headers` if you passed custom params.
    // For now, assuming callerUser is the GUID or mapping required.
    
    // Example: Assuming the user part of SIP URI is the GUID
    const paramsDoctorInfo = {
       guid: callerUser, // or parse from headers
       reg_code: utilService.getNetwork(),
       n2n_network: "" // Logic to extract network if sent in SIP headers
    };
    
    if (callerUser) {
       fetchCallerInfo(paramsDoctorInfo);
    }
  };

  // --- JsSIP CALL ACTIONS EXPOSED FOR CHILDREN ---

 const startCall = (destination: string) => {
  if (!userAgent || !registered) {
    // Toast.error('Phone Service Not registered'); // Uncomment if you have Toast
    console.error('Phone Service Not registered');
    return;
  }

const options = {
 
 extraHeaders: [
    `X-User-Id: ${loggedInUserGuid}`,
  ],
  eventHandlers: {
    progress: () => {
      console.log('Ringing...');
    },

    failed: (e: any) => {
      console.log('Call Failed:', e?.cause);
      setSession(null);
    },

    ended: () => {
      console.log('Call Ended');
      setSession(null);
    },

    confirmed: () => {
      console.log('Call Confirmed (In Call)');
    },
  },

  mediaConstraints: {
    audio: true,
    video: false,
  },

  sessionTimersExpires: 120,

  iceServers: iceServers(),
};

  // 1. Initiate the call
  const newSession = userAgent.call(`sip:${destination}@${sipServer()}`, options);

  // 2. Attach the Media Handler using the Event Listener (The Fix)
  newSession.on('peerconnection', (data: any) => {
    console.log('PeerConnection Created for Outgoing Call');
    
    // When the remote stream arrives (audio from the other person)
    data.peerconnection.ontrack = (event: any) => {
      console.log('Remote Audio Track Received:', event.streams[0]);
      
      if (remoteAudioRef.current) {
        // Set the source to the incoming stream
        remoteAudioRef.current.srcObject = event.streams[0];
        
        // Ensure volume is up and unmuted
        remoteAudioRef.current.volume = 1.0;
        remoteAudioRef.current.muted = false;

        // Force play (Browser autoplay policies sometimes block this)
        remoteAudioRef.current.play()
          .then(() => console.log('Remote Audio Playing Successfully'))
          .catch((err) => console.error('Audio Playback Failed (Autoplay blocked?):', err));
      } else {
        console.error('CRITICAL: Audio Element Ref is Missing!');
      }
    };
  });

  setSession(newSession);
};

  const answerCall = () => {
    if (!session) return;
    session.answer({ mediaConstraints: { audio: true, video: false } });
  };

  const hangupCall = () => {
    if (session) {
      session.terminate();
      setSession(null);
    }
  };

  // ------------------------------------------------

  useEffect(() => {
    // This effect ensures modal opens if connection and doctor info are present
    // Adapted for SIP Session presence
    if (!_.isEmpty(session) && !_.isEmpty(doctorInfoData)) {
      // Logic to verify if call is for logged in user (usually handled by SIP server routing)
      // keeping logic generic here
       setShowIncomingCallUserModal(true);
    }
  }, [doctorInfoData, session]); // Changed incomingConnection to session

  async function fetchCallerInfo(params: DoctorInfoReq) {
    const respDoctorListResult: any = await smsService.getDoctorInformation(
      params
    );
    if (respDoctorListResult.isSuccess) {
      setDoctorInfoData(_.cloneDeep(respDoctorListResult.result.userData));
    } else {
      smsService.handleErrorResponse();
    }
  }

  useLayoutEffect(() => {
    pushNotificationService.notificationClicked.subscribe((status: boolean) => {
      if (status) {
        history.push("/client/notifications");
      }
    });
  }, []);

  useEffect(() => {
    ReminderAlertService.getReminderAlerts([]);
  }, []);

  const timerParams = {
    reg_code: utilService.getNetwork(),
  };

  useEffect(() => {
    ContactNumAlertService.fetchContactTimerInfo(timerParams);
  }, []);

  useEffect(() => {
    checkIfSmallScreen();
    if (isPlatform("ios")) {
      setIsIos(true);
    }
    const isDarkMode = getThemeStatusFromStorage();
    toggleDarkModeHandler(isDarkMode);
  }, []);

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const getThemeStatusFromStorage = () => {
    const savePassword = utilService.getSavePasswordStatus();
    const isDarkMode = StorageService.getStorageItem(
      CONSTANTS.STORAGE[true === savePassword ? 1 : 0],
      "isDarkMode",
      true
    );
    if (isDarkMode === "true") {
      return true;
    } else {
      return false;
    }
  };

  const toggleDarkModeHandler = (status: boolean) => {
    document.body.className = status ? "dark-theme" : "light-theme";
    settingsService.themeSwitch = status;
  };

  return (
    <CallProvider>
    <div>
      {/* Signs the user out after a period with no interaction. Mounted here,
          in the authenticated shell, so it never runs on the login screen. */}
      <IdleTimeout />

      {/* Hidden Audio Element for SIP Calls */}
      <audio ref={remoteAudioRef} style={{ display: 'none' }} />
      
      {reminderList?.length>0 &&
        reminderList?.map((reminder) => {
          return (
            <ReminderAlert
              reminderList={reminderList}
              reminderInputParams={reminder}
            ></ReminderAlert>
          );
        })}
      {showContactModalAlert && (
        <ContactNumAlert
          showContactNumAlert={showContactModalAlert}
          showAlert={() => setShowContactModalAlert(false)}
          contactNumInputParams={contactNumAlertParams}
        ></ContactNumAlert>
      )}

      {emsPatientStatus && (
        <PatientAlert
          showPatientAlert={emsPatientStatus}
          showAlert={() => setEMSPatientStatus(false)}
          patientInputParams={patientInfoData}
          isFromRejectStatus={false}
        ></PatientAlert>
      )}

      {emsRejectedPatientStatus && (
        <PatientAlert
          showPatientAlert={emsRejectedPatientStatus}
          showAlert={() => setEMSRejectedPatientStatus(false)}
          patientInputParams={rejectedPatientInfoData}
          isFromRejectStatus={true}
        ></PatientAlert>
      )}

      {emsProviderAlertStatus && (
        <ProviderAlert
          showPatientAlert={emsProviderAlertStatus}
          showAlert={() => setEmsProviderAlertStatus(false)}
          patientInputParams={providerEmergencyCaseListData}
          isFromRejectStatus={false}
        ></ProviderAlert>
      )}

      {emsCareTeamAlertStatus && (
        <CareTeamEmergencyAlert
          showPatientAlert={emsCareTeamAlertStatus}
          showAlert={() => setEmsCareAlertStatus(false)}
          patientInputParams={careTeamListData}
          isFromCareTeamMembersAlert={true}
        ></CareTeamEmergencyAlert>
      )}
      <div
        ref={headerWrapperRef}
        style={{
          ["--sidebar-width" as any]: isCollapsed ? "64px" : "220px",
        }}
      >
        <MenuContext.Provider value={{ menuListGlobal, setMenuListGlobal }}>
          <Header isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}></Header>
        </MenuContext.Provider>
      </div>

      <IonSplitPane
        contentId="main"
        className={`main ${isIos && "main-iOs"}`}
        style={{ ["--header-height" as any]: `${headerHeight}px` }}
      >
        <MenuContext.Provider value={{ menuListGlobal, setMenuListGlobal }}>
          <Menu isCollapsed={isCollapsed} />
        </MenuContext.Provider>

        <IonRouterOutlet id="main" className="page-content">
          <Suspense fallback={""}>
            <Route exact path="/client" component={Home} />
            <Route exact path="/client/home" component={Home} />
            <Route exact path="/client/emt-home" component={EmtHomeComponent} />
            <Route
              exact
              path="/client/case-history"
              component={CaseHistoryComponent}
            />
            <Route
              exact
              path="/client/emt-patient-form"
              component={PatientFormComponent}
            />
            <Route
              path="/client/unassigned-shift"
              component={UnassignedShift}
            />
            <Route
              exact
              path="/client/call-schedule"
              component={CallSchedule}
              routerDirection="root"
            />
            <Route
              exact
              path="/client/oncalllookup"
              component={onCallLookUpMainPage}
            />
            <Route
              exact
              path="/client/globalUserSearch"
              component={SearchWithSelectBar}
            />
            <Route
              exact
              path="/client/favorites"
              component={OnCallLookUpFavComponent}
            />
            <Route
              exact
              path="/client/:id/units"
              component={UnitDeptListPage}
            />
            <Route exact path="/client/sites" component={SitesPage} />
    

             <Route
              exact
              path="/client/nurse-management"
              component={NurseManagement}
            />
            <Route
              exact
              path="/client/status-board/:id"
              component={StatusBoardMainPage}
            />
            <Route exact path="/client/:id/beds" component={UnitBeds} />
            <Route exact path="/client/my-patients" component={MyPatients} />
            <Route exact path="/client/teams" component={TeamsPage} />
            <Route
              exact
              path="/client/notifications"
              component={Notifications}
            />
            <Route
              exact
              path="/client/menu-settings"
              component={MenuSettings}
            />
            <Route path="/client/messages" component={UserChatMainPage} />
            <Route path="/client/membership" component={MembershipPlan} />
            <Route path="/client/usermessages" component={UserMessage} />
            <Route path="/client/file-share/" component={FileShareMainPage} />
            <Route path="/client/n2n-search" component={N2NGlobalSearch} />

            {/* NOTE: do not add a pathless catch-all Route here. IonRouterOutlet
                does not behave like a Switch in this tree -- a <Route render>
                with no path matched every URL and sent every screen to Home.
                An unknown /client/* path still renders an empty shell; fixing
                that needs an explicit not-found path, not a catch-all. */}

          </Suspense>
        </IonRouterOutlet>
      </IonSplitPane>
      {isSmallScreen && !isEMTUser && (
        <div className="footer-menu" id="tabFooter">
          <FooterMenu></FooterMenu>
        </div>
      )}
      {showCareTeamPopup && (
        <CareTeamAlert
          showCareTeamAlert={showCareTeamPopup}
          showAlert={() => setShowCareTeamPopup(false)}
          careTeamInputParams={careTeamAlertParams}
        ></CareTeamAlert>
      )}
      
      {/* Updated IncomingCallUser to use JsSIP Props 
          Note: You likely need to update IncomingCallUser to accept 'session' 
          instead of 'twilioDevice' and 'connection' and use .answer()/.terminate() 
      */}
    {userAgent && doctorInfoData && (
  <IncomingCallUser
    showIncomingCallUserModal={showIncomingCallUserModal}
    doctorInfoData={doctorInfoData}
    enableIncomingScreen={enableIncomingScreen}
    userAgent={userAgent} 
    session={session} 
    
    // Action: User clicked Answer
    onAnswer={answerCall} 
    
    // Action: User clicked Reject/Hangup
    onHangup={hangupCall} 
    
    // Action: Modal is closing (Cleanup UI only)
    onOk={() => {
      setShowIncomingCallUserModal(false);
      setIncomingScreen(false);
    }}
    
    // Action: Explicit Cancel (Cleanup UI only)
    onCancel={() => {
      setShowIncomingCallUserModal(false);
      setIncomingScreen(false);
    }}
  />
)}
    </div>
    </CallProvider>
  );
};

export default AppLayout;